import { createStyles, makeStyles } from '@material-ui/core';
import { variables } from '../../../../styles';

export const useStyles = makeStyles(() =>
  createStyles({
    dialog: {
      width: 900,
      height: 300,
      borderRadius: 16,
      padding: '16px 32px 32px 32px',
      flexDirection: 'column',
      justifyContent: 'space-between',

      '@media (max-width: 600px)': {
        height: 'auto',
      },
    },
    newDialog: {
      width: 900,
      height: 398,
      borderRadius: 16,
      padding: '16px 32px 32px 32px',
      flexDirection: 'column',
      justifyContent: 'space-between',

      '@media (max-width: 600px)': {
        height: 'auto',
      },
    },
    margin: {
      marginTop: 22,
    },
    multiSelect: {
      '@media (max-width: 600px)': {
        width: 440,
      },

      '@media (max-width: 430px)': {
        width: 298,
      },

      '@media (max-width: 390px)': {
        width: 259,
      },
    },
    option: {
      '& span': {
        marginLeft: 20,
      },
      '& svg path': {
        stroke: variables.black10,
      },
    },
    selectedOption: {
      '& svg path': {
        stroke: variables.richBlack,
      },
      '& span': {
        marginLeft: 20,
      },
    },
    dialogAction: {
      marginTop: 20,
      flexDirection: 'column',
      paddingLeft: 0,
      paddingRight: 0,
      alignItems: 'flex-start',
    },
    btn: {
      padding: 16,
      '& .MuiButton-startIcon': {
        width: 19,
        height: 13,
      },
    },
    placeholder: {
      color: '#030C2133',
    },
    hide: {
      display: 'none',
    },
  }),
);
